import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import bulbImg from '../../images/bulb.png'


export default class CaseStudies extends React.Component{

logout() {
  logout()
  this.setState({ loggedOut: true })
}



render() {
  return(
  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="NewformaLogo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>

        {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">

          <span className="orange-bold"> NEWFORMA </span> Your partner for all things AECO project information management. <a className="newforma-world-link" href="https://www.newforma.com/">Learn More</a>
      </div>



<div className="main-content">
<div className="content-wrap">
<div className="col-narrow">
<p className="develop-header">Case Studies</p>
<p className="bodyP">Discover how other customers have used our APIs to gain more value out of Newforma.</p>

</div>

<div className="col-wide">
<img src={bulbImg} className="Curly-logo" alt="idea" />
</div>
</div>
</div>




</div>







    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/CaseStudies/index.js
 **/